// extracted by mini-css-extract-plugin
module.exports =  {"content":"so8Ya2N","variant-white":"Ggszb08","variantWhite":"Ggszb08"};